(function () {
    'use strict';

    /**
     *
     * @ngdoc service
     * @name adminCrewBatchers.service:CrewBatchService
     *
     * @description
     *
     */
    angular
        .module('renewals')
        .service('RenewalsService', RenewalsService);

    function RenewalsService(RenewalsFactory, RemoteService, CrewingHelper, MessageService, CrewingAdaptor, EventManagerService) {
        var self = this;

        self.searchGridData = function (postData, successFn, errorFn) {
            var request = RenewalsFactory.populateGridDataSearchRequest(postData);
            RemoteService.searchRenewals(request).then(
                function (response) {
                    var gridData = RenewalsFactory.formatGridDataSearchResponse(response.crewSearchExpiryList);
                    successFn(gridData, response.startPosition);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.searchCrewTypes = function (successFn, errorFn) {
            RemoteService.getCrewTypeList().then(
                function (response) {
                    var formatedList = RenewalsFactory.formatCrewTypeResponse(response.crewTypeListDTOs);
                    successFn(formatedList);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.searchValidationTypes = function (successFn, errorFn) {
            RemoteService.getValidationTypes().then(
                function (response) {
                    var formatedList = RenewalsFactory.formatValidationTypeResponse(response.validationTypeCollection);
                    successFn(formatedList);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.searchValidations = function (data, successFn, errorFn) {
            var postData = RenewalsFactory.populateValidationSearchRequest(data);
            RemoteService.loadValidations(postData).then(
                function (response) {
                    var formatedList = RenewalsFactory.formatValidationsResponse(response.validationCollection);
                    successFn(formatedList);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.searchFleetTypes = function (successFn, errorFn) {
            RemoteService.getAircraftTypeList().then(
                function (response) {
                    var formatedList = RenewalsFactory.formatFleetTypeResponse(response.aircraftTypeDTOs);
                    successFn(formatedList);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.searchCrewBases = function (successFn, errorFn) {
            RemoteService.getBaseList().then(
                function (response) {
                    var formatedList = RenewalsFactory.formatCrewBaseResponse(response.baseListDTOs);
                    successFn(formatedList);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.getNewRenewal = function () {
            return RenewalsFactory.getNewRenewal();
        };

        self.getScheduleTrainingByExpiry = function(selectedExpiry){
            return RenewalsFactory.scheduleTrainingSearchRQ(selectedExpiry);
        };

        self.getAdaptedCrewList = function (crewList) {
            return _.map(crewList, function (crew) {
                return RenewalsFactory.getCrewFormatted(crew);
            });
        };

        self.getCrewByCrewId = function (list, crewId) {
            return _.find(list, {'crewId':crewId});
        };

        self.assignTrainerTrainee = function (param,successFn, errorFn) {
            RemoteService.assignTrainerTrainee(param,true).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.unAssignTrainerTrainee = function (param,successFn, errorFn) {
            RemoteService.unAssignTrainerTrainee(param,true).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.getAvailableTrainings = function (params, successFn, errorFn) {
            RemoteService.getAvailableTraining(params).then(
                function(response){
                    successFn(response)
                },
                function (error) {
                    errorFn(error);
                }
            )  
        };
        
        self.adaptTrainingSchedules = function (trainings) {
            var formatted = _.map(trainings, function(training){
                var mmD = moment(training.trainingStartDateStr, 'DD/MM/YYYY');
                return {
                    dateDisplay: mmD.format('Do'),
                    monthDisplay: mmD.format('MMMM'),
                    date: mmD.format('DD/MM/YYYY'),
                    startTime: training.trainingStartTimeStr,
                    endTime: training.trainingEndTimeStr, 
                    location: training.locationCode,
                    slotId: training.trainingSlotId,
                    slotProgramId: training.trainingSlotProgramId,
                    programId: training.trainingProgramId,
                    programDetailId: training.trainingProgramDetailId,
                    assignedCrew:  training.assignedCrew,
                    crewRequirement : training.crewRequirement,
                    category: training.programCategoryCode,
                    crewAssigned: training.searchedCrewAssigned
                };
            });
            var filtered = _.groupBy(formatted, 'category'), catArray=[];
            for (var category in  filtered){
                catArray.push({category:category, categoryData: filtered[category]});
            }
            return catArray;
        };

        self.getTrainerTraineeList = function () {
            return [
                {
                    title: 'Trainee',
                    value: 'TRAINEE'
                },
                {
                    title: 'Trainer',
                    value: 'TRAINER'
                }
            ];
        };

        self.getTrainerTypes= function(successFn, errorFn) {
            RemoteService.getTrainerTypes().then(
                function (response) {
                    successFn(response.trainerTypeList);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        /**
         * Assign Training logic
         * @param training
         */
        self.assignTraining = function (discrepancyTraining, crewInfo, assignFlag) {
            var flags = {
                isContinueIllegal: true,
                isUserConfirm: false,
                isExpiryUpdatable: false,
                isIgnoreConflicts: false,
                isIgnoreExpiry: false
            };

            var training = RenewalsFactory.createTrainingForAssign(discrepancyTraining);
            var trainingData = {};
            trainingData.crewProfileId = crewInfo.crewProfileId;
            trainingData.trainingSlotId = training.trainingSlotId;
            trainingData.trainingSlotProgramId = training.trainingSlotProramId || null;
            trainingData.trainingProgramId = training.trainingProgramId;
            trainingData.trainingProgDetailId = training.trainingProgramDetailId;
            trainingData.assignAsCrewType = crewInfo.crewType;
            trainingData.assignDate = training.startDateZulu;
            trainingData.assignTime = training.startTimeZulu;
            trainingData.courseId = null;
            trainingData.courseTxnId = null;
            trainingData.assign = assignFlag;
            

            var onAssignSuccess = function () {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.RENEWALS.ASSIGN_TRAINING);
            };

            var onCancel = function () {
                training.isAssigned = false;
            };


            var doAssign = function (params, flags) {
                params.continueIllegal = !!flags.isContinueIllegal;
                params.userConfirm = !!flags.isUserConfirm;
                params.expiryUpdatable = !!flags.isExpiryUpdatable;
                params.ignoreConflicts = !!flags.isIgnoreConflicts;
                params.ignoreExpiries = !!flags.isIgnoreExpiry;

                RemoteService.assignTrainerTrainee(params,true).then(
                    function (response) {
                        var adapted = CrewingAdaptor.assignTrainingAdaptor(response);
                        CrewingHelper.assignTrainingActionList(params, adapted, flags, doAssign, onAssignSuccess, onCancel);
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            };

            doAssign(trainingData, flags);
        };

    }
})();